
import { defineComponent } from "@vue/composition-api";
import { IDataProviderRequest } from "@/interfaces/data-provider";
import { useCatalog } from "@/store/catalog";
import { useMetadataCatalog } from "@/store";
import { mapState } from "pinia";
import MetadataEditor from "@/views/MetadataEditor.vue";
import AddNewMetadata from "@/components/AddNewMetadata.vue";

export default defineComponent({
  name: "MetadataManager",
  components: {
    MetadataEditor,
    AddNewMetadata,
  },
  props: {
    selectedFromDataViewer: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    showMetadata: false,
    dpRequest: {} as IDataProviderRequest,
    tabIndex: null as any,
    isLoading: false,
    currentPage: 1,
    perPage: 12,
    sortBy: "",
    sortDesc: false,
    modes: ["multi", "single", "range"],
    selectMode: "single",
    selected: [],
    totalRows: 1,
    filter: "",
    filterOn: [],
    isMetaRowDisabled: true,

    allowEditing: false,
    addBtnClicked: false,
    whichMetadata: null as any,
    editBtnClicked: false,
    displayPopupShade: false,
  }),
  computed: {
    ...mapState(useMetadataCatalog, [
      "categories",
      "selectedCategory",
      "items",
      "columnNames",
      "selectedDataCatId",
      "updateLogId",
      "workflowBucket",
    ]),
    selectedCategoryId: {
      get(): string {
        return useMetadataCatalog().selectedCategoryId;
      },
      set(val: string) {
        useMetadataCatalog().selectedCategoryId = val;
      },
    },
    selectedDataCatId: {
      get(): number {
        return useMetadataCatalog().selectedDataCatId;
      },
      set(val: number) {
        useMetadataCatalog().selectedDataCatId = val;
      },
    },
    updateLogId: {
      get(): number {
        return useMetadataCatalog().updateLogId;
      },
      set(val: number) {
        useMetadataCatalog().updateLogId = val;
      },
    },
  },
  watch: {
    tabIndex: {
      handler(val) {
        if (this.selected?.length) {
          this.selectedCategoryId = this.categories[val].id;
          this.loadData();
        }
      },
    },
    "selected.length": {
      handler(val) {
        if (!val) {
          // console.log("inside watch handler - val, ", val);
          // this.selectedCategoryId = this.categories[0].id;
          // this.loadData();
        }
      },
    },
  },
  mounted() {
    this.selectedCategoryId = "v_data_cat";
    this.catalogChange();
    if (this.selectedFromDataViewer !== null) {
      this.showMetadataForDataviewer(this.selectedFromDataViewer);
    }
  },
  methods: {
    init() {
      this.filter = "";
      this.catalogChange();
    },
    async loadData() {
      const editTables = ["v_field_cat", "v_data_desc_cat"];
      if (editTables.includes(this.selectedCategory.id)) {
        this.allowEditing = true;
      } else {
        this.allowEditing = false;
      }
      useMetadataCatalog().updateData(this.selectedCategoryId, null);
      this.isLoading = true;
      if (!this.meta) {
        const meta = await useCatalog().getTableMeta({
          catalogUri: this.selectedCategory.uri,
          request: {},
          updateState: false,
        });
        useMetadataCatalog().updateMeta(this.selectedCategoryId, meta);
      }
      let filterField = "data_cat_id";
      let filterValue = this.selected?.length
        ? this.selected[0][filterField]
        : "";

      if (this.selected.length) {
        switch (this.selectedCategoryId) {
          case "v_spatial_cat":
            filterField = "spatial_cat_id";
            filterValue = this.selected.length
              ? this.selected[0][filterField]
              : "";
            break;
          case "v_provider_cat":
            filterField = "provider_cat_id";
            break;
          case "v_field_publish_cat":
            filterField = "publish_data_cat_id";
            break;
          case "v_licence_cat":
            filterField = "primary_data_cat_id";
            break;
          default:
            filterField = "data_cat_id";
            break;
        }
      }
      const data = await useCatalog().getTableData({
        catalogUri: this.selectedCategory.uri,
        request: {
          orderBys: [{ columnName: filterField, keyword: "asc" }],
          filter: this.selected.length
            ? [
                {
                  fieldName: filterField,
                  filterOperator: 0,
                  value: filterValue,
                  conditionOperator: 0,
                },
              ]
            : [],
        },
        updateState: false,
      });
      useMetadataCatalog().updateData(this.selectedCategoryId, data);
      this.isLoading = false;
    },
    async catalogChange() {
      if (this.selectedCategory.id === this.selectedCategoryId) {
        const category = this.selectedCategory;
        if (!this.meta) {
          const meta = await useCatalog().getTableMeta({
            catalogUri: category.uri,
            request: {},
            updateState: false,
          });
          useMetadataCatalog().updateMeta(category.id, meta);
        }
        this.loadData().then();
      }
    },
    async onRowSelected(items: never[]) {
      if (items.length > 0) {
        if (
          items[0]["dataset_name"] !== null ||
          items[0]["dataset_name"] !== undefined ||
          items[0]["dataset_name"] !== ""
        ) {
          this.selected = items;
          this.setDataCatId(items[0]["data_cat_id"]);
          this.setUpdateLogId();
          this.showMetadata = true;
        }
      } else {
        this.selected = [];
        this.setDataCatId(null);
      }
    },
    setDataCatId(dataCatId: any) {
      this.selectedDataCatId = dataCatId;
    },
    async setUpdateLogId() {
      const data = await useCatalog().getTableData({
        catalogUri: "/meta_cat/89",
        // catalogUri: "/data_mgmt/all/System/v_update_log",
        request: {
          orderBys: [{ columnName: "update_log_id", keyword: "desc" }],
          filter: this.selected.length
            ? [
                {
                  fieldName: "data_cat_id",
                  filterOperator: 0,
                  value: this.selectedDataCatId,
                  conditionOperator: 0,
                },
              ]
            : [],
        },
        updateState: false,
      });
      this.updateLogId = data.rows[0][0];
    },
    closeMetaPopup() {
      this.addBtnClicked = false;
      this.displayPopupShade = false;
      this.init();
    },
    showCatSelector() {
      this.showMetadata = false;
      this.selected = [];
      this.tabIndex = null;
      this.selectedCategoryId = "v_data_cat";
      this.init();
    },
    onFiltered(filteredItems: string | any[]) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems?.length;
      this.currentPage = 1;
    },
    showAddNewMetadataBtn(catName: string) {
      if (
        (catName === "v_data_desc_cat" || catName === "v_update_cat") &&
        this.items.length > 0
      )
        return false;
      else return this.workflowBucket.includes(catName);
    },
    addNewMetadata(catName: string) {
      if (catName.startsWith("v_")) {
        catName = catName.substring(2);
      }
      this.whichMetadata = catName;
      this.addBtnClicked = true;
      this.displayPopupShade = true;
    },
    editMetadata() {
      if (this.selected.length > 0) {
        this.editBtnClicked = true;
        this.displayPopupShade = true;
      } else {
        this.$root.$emit(
          "showAlert",
          4,
          "danger",
          "Please select a row from the table!"
        );
      }
    },
    closePopup() {
      this.editBtnClicked = false;
      this.addBtnClicked = false;
      this.displayPopupShade = false;
    },
    // async viewMetadata() {
    //   if (this.selected.length > 0) {
    //     this.showMetadata = true;
    //   } else {
    //     this.$root.$emit(
    //       "showAlert",
    //       4,
    //       "danger",
    //       "Please select a row from the table!"
    //     );
    //   }
    // },
    async showMetadataForDataviewer(items: any) {
      await this.onRowSelected(items);
      // await this.viewMetadata();
    },
  },
});
